import styled from 'styled-components';

export const Wrapper = styled.main`
    min-height: 100vh;
    min-width: 100%;
    display: flex;
    justify-content: center;

    & > div {
        width: 100%;
        min-height: 100%;
        display: flex;

        &:last-child {
            display: none;
        }
    }
`;
